import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Userclass } from '../Classes/Userclass';

@Injectable()
export class WebJobService {

  constructor(private http: Http) { }

  GetWebJobDetails() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/AutoImport/GetWebJobDetails', options)
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/WebJobService.ts